import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTE_PATHS } from '@/config/app.config'

/**
 * `/reset-mfa` — target of the admin-initiated MFA-reset email
 * (`${APP_URL}/reset-mfa?token=…`).
 *
 * The reset immediately revokes the user's 2FA and downgrades them to
 * `emailVerified: false`, so re-enrolment happens through the normal
 * first-login flow: sign in → email OTP (`/login/verify-email`) → scan the new
 * QR (`/login/setup-authenticator`) → verify the authenticator
 * (`/login/verify-app`). The one-time `token` isn't needed by the client, so
 * this route simply funnels the link into `/login`.
 */
export const Route = createFileRoute('/reset-mfa')({
  beforeLoad: () => {
    throw redirect({ to: ROUTE_PATHS.login })
  },
})
